import Keycloak from "keycloak-js";

const keycloakSingleton = new Keycloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

class KeycloakService {
    constructor() {
        this.keycloak = keycloakSingleton;

        this.init_args = {
            checkLoginIframe: false,
            onLoad: 'login-required'
        };
    }

    async login() {
        if( this.keycloak.authenticated ) {
            return true;
        }

        await this.keycloak.init(this.init_args);
        return this.keycloak.authenticated;
    }

    async logout() {
        this.keycloak.logout()
    }

    getToken() {
        return this.keycloak.token;
    }

    getTokenParsed() {
        return this.keycloak.tokenParsed;
    }

    getAccountUrl() {
        return this.keycloak.createAccountUrl();
    }

}

const keycloakService = new KeycloakService();


export default keycloakService;